import { render, staticRenderFns } from "./PollSuggestManage.vue?vue&type=template&id=7319355e&"
import script from "./PollSuggestManage.vue?vue&type=script&lang=js&"
export * from "./PollSuggestManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7319355e')) {
      api.createRecord('7319355e', component.options)
    } else {
      api.reload('7319355e', component.options)
    }
    module.hot.accept("./PollSuggestManage.vue?vue&type=template&id=7319355e&", function () {
      api.rerender('7319355e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/poll/poll-suggest/PollSuggestManage.vue"
export default component.exports